import angular from 'angular'
import template from './template.html'

angular.module('nominas.pendientes')
  .component('nominasPendientesCotizarProyectoNominaEnviar', {
    template: template,
    controller: NominasPendientesCotizarProyectoNominaEnviarComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      status: '<',
      editable: '<',
      onChange: '&',
    },
  });

function NominasPendientesCotizarProyectoNominaEnviarComponent(NominasNominaStatusCotizado) {
  let $ctrl = this;
  $ctrl.toggle = toggle;
  $ctrl.actualizando = false;

  function toggle() {
    if ($ctrl.actualizando)
      return;

    $ctrl.actualizando = true;

    return NominasNominaStatusCotizado.put($ctrl.idEmpresa, $ctrl.idNomina, {
        status_cotizado: !$ctrl.status,
      })
      .then(function (response) {
        $ctrl.onChange({$event: {data: response.data}});
      })
      .finally(function () {
        $ctrl.actualizando = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/pendientes/components/cotizar/proyecto/nomina/enviar/component.js